module.exports = {
    hotspotClick: 'HOTSPOT',
    hintAreaClick: 'HINTAREA',
    floorMenuClick: 'FLOOR_SELECTOR',
    initialLoad: 'TOUR_START',
    spaceClick: 'SPACE_MENU',
    history: 'HISTORY_API'
};
